"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var util_1 = require("../util");
var State_1 = require("../State");
var renderProp_1 = tslib_1.__importDefault(require("../util/renderProp"));
var faccToHoc_1 = tslib_1.__importDefault(require("../util/faccToHoc"));
exports.Toggle = function (props) {
    return util_1.h(State_1.State, {
        init: { on: props.init || false },
        render: function (_a, set) {
            var on = _a.on;
            return renderProp_1.default(props, {
                on: on,
                toggle: function () { return set({ on: !on }); },
                set: function (on) { return set({ on: on }); }
            });
        }
    });
};
exports.withToggle = faccToHoc_1.default(exports.Toggle, 'toggle');
//# sourceMappingURL=index.js.map